export enum InFeedAdDisplayAt {
  BrochuresGrid = "BROCHURES_GRID",
  OffersGrid = "OFFERS_GRID",
}
